export default {
  /**
   * Новый словарь для хранения объектов источников данных (левая панель)
   */
  dataSourceObjects: {},

  /**
   * Новый словарь для хранения объектов слоя (левая панель)
   * count
   * objects
   */
  layerObjects: {},

  /**
   * Стили слоев
   */
  layerStyles: {},

  /**Показать маршрут для выбранного объекта линейного информационного слоя */
  showRouteForSelectedStreaminfoObject: false,

  /**Показать маршрут для выбранной кп - храним id выбранной кп*/
  showRouteForContainerPlatform: null,

  /**Список иконок инфослоев */
  infoLayerIcons: [],

  /**
   * Словарь слоев, у которых есть раскраски
   * Ключ - идентификатор слоя (сущности)
   * Значение - название
   */
  coloringLayerNames: {},

  /**
   * Словарь раскрасок
   * Ключ - идентификатор раскраски
   * Значение - {id, name}
   */
  colorings: {},

  /**
   * Словарь раскрасок, доступных для слой
   * Ключ - идентификатор слоя (сущности)
   * Значение - массив идентификаторов доступных раскрасок
   */
  layerColorings: {},

  /**
   * Связи раскрасок и слоев для переключения
   * Ключ - идентификатор раскраски
   * Значение - объект, в котором ключ - идентификатор слоя, а значение Boolean (включена или выключена)
   */
  layerColoringConnections: {},

  /**
   * Данные выбранного объекта, которые пришли с сревера в "сыром" виде
   */
  rawSelectedObjectInfo: null,

  /**
   * Специальная очередь методов, которые должна вызвать карта
   * хранить надо название метода и обхект с параметрами
   * такое решение, чтобы вызвать методы лифлета, но при этом не хранить объекты лифлета в vuex
   * возможно это костыль
   */
  mapMethodsQueue: [],

  /**
   * Текст для фильтрации слоев на клиенте с помощью быстрого поиска
   */
  layerFilterText: '',

  /**
   * Идентификаторы слоев, который были раскрыты из-за поиска
   */
  openedBySearchLayerIds: []
}



// WEBPACK FOOTER //
// ./src/store/objects/defaultsNewStructure.js